import React, { useState, useEffect, useCallback } from "react";
import { Helmet } from "react-helmet";
import { Link, useLocation } from "react-router-dom";

import Header from "../../components/header";
import DateIcon from "../../shared/icons";
import CardRound from "../../components/cardround";
import { dataListsType } from "../../shared/type";
import { DataLists } from "../../dataLists/DataLists";
import { useStreamingRender } from "./useStreamingRender";
// import AFSSearchPageAd from "../../components/AFSSearchPageAd";

export default function TestAnswer() {
  const location = useLocation();
  const planData = location.state?.planData;

  const [destinationData, setDestinationData] = useState<dataListsType[]>([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const bookingLinks = [
    {
      label: "Trip.com",
      img: "/icon/hk_trip.webp",
      href: "https://hk.trip.com/?locale=en-hk",
    },
    {
      label: "Expedia.com.hk",
      img: "/icon/expedia_hk.svg",
      href: "https://www.expedia.com.hk/en/Sale.d180178.Travel?semcid=HK.UB.GOOGLE.DL-DSA-c-EN.PACKAGE&semdtl=a114179647541.b1125052471349.g1dsa-1395432991658.e1c.m1CjwKCAiAs4HMBhBJEiwACrfNZRVgFpucmMA09c4Yx1w_cI1u8E0kWcGteGTAz1k7dbHRidRhpOSyiRoCZ-0QAvD_BwE.r1.c1.j19198854.k1.d1661468850866.h1.i1.l1.n1.o1.p1.q1.s1.t1.x1.f1.u1.v1.w1&gad_source=1&gad_campaignid=14179647541&gbraid=0AAAAACTxZ9b5_eswWoAYqzNLPfb1Xx4G5&gclid=CjwKCAiAs4HMBhBJEiwACrfNZRVgFpucmMA09c4Yx1w_cI1u8E0kWcGteGTAz1k7dbHRidRhpOSyiRoCZ-0QAvD_BwE",
    },
    {
      label: "Agoda.com",
      img: "/icon/agoda.svg",
      href: "https://www.agoda.com/zh-hk/pages/agoda/default/DestinationSearchResult.aspx?area=574689&site_id=1922864&tag=3eb76572-c660-4c1a-9789-fd7ecda77d0b&gad_source=1&gad_campaignid=21255847379&gbraid=0AAAAA9_WXQq67d3O3882dX9LGbCdZkq8S&gclid=CjwKCAiAs4HMBhBJEiwACrfNZYyfTqaxe7ass6ATkvkb9WIETVH2xqTLCEWycB3YoCgyEl7dmuB8ahoCuL4QAvD_BwE&ds=AmmjD8jReXck0dWm",
    },
  ];

  // 使用流式渲染 Hook
  const streamingState = useStreamingRender(planData);

  const getDestinationData = useCallback(() => {
    const data = DataLists.filter((item: dataListsType) =>
      planData?.destination
        .trim()
        .toLowerCase()
        .includes(item.nation.toLowerCase())
    );
    setDestinationData(data);
  }, [planData?.destination]);

  useEffect(() => {
    getDestinationData();
  }, [getDestinationData]);

  const formatDate = (dateStr: string) => {
    if (!dateStr) return "";
    const dates = dateStr.split("–");
    if (dates.length !== 2) return "";

    const formatSingleDate = (date: string) => {
      const d = new Date(date.trim());
      return `${d.getDate()}/${d.getMonth() + 1}`;
    };

    return `${formatSingleDate(dates[0])} - ${formatSingleDate(dates[1])}`;
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!planData) {
    return (
      <>
        <Header />
        <div className="w-full flex justify-center items-center min-h-screen">
          <div className="text-gray-500">Loading travel plan...</div>
        </div>
      </>
    );
  }

  return (
    <>
      <Header />

      <Helmet>
        <title>Your AI Travel Plan - Explore Asia</title>
        <meta
          name="description"
          content="View your personalized AI-generated travel itinerary with detailed day-by-day plans, local food recommendations, and travel tips."
        />
      </Helmet>

      <div className="w-full flex justify-center relative">
        <div className="w-full h-full fixed top-5 left-0 -z-10 bg-white/90 bg-blend-overlay backdrop-blur-md">
          {/* <img
            src="/images/crafts4.png"
            alt=""
            className="w-full h-full opacity-20 object-cover blur-sm"
          /> */}
        </div>
        <div
          className={`max-w-[1200px] w-full h-full flex flex-col items-center ${
            windowWidth > 800 ? "px-0" : "px-0"
          } py-8`}
        >
          <div
            className={`w-full ${
              windowWidth > 800 ? "rounded-lg shadow-none p-6" : "px-4"
            } `}
          >
            <div
              className={`flex ${
                windowWidth > 800 ? "w-[76%] items-center" : "w-full flex-col"
              }  p-6 bg-slate-0`}
            >
              <h1 className="md:text-4xl text-[34px] font-extrabold mr-4">
                Trip to {planData.destination}
              </h1>

              <div className="flex items-end pt-2">
                <DateIcon isActive={true} />
                <span className="text-[#636c75] text-base font-bold ml-1">
                  {formatDate(planData?.travelPeriod)}
                </span>
              </div>
            </div>

            {/* <AFSSearchPageAd
              key={planData?.destination?.trim().toLowerCase()} // ✅ query 變就強制重建
              enabled={true}
              query={planData?.destination?.trim().toLowerCase()}
              pageName="test-answer-page"
            /> */}

            <div
              className={`w-full ${windowWidth > 800 ? "px-10" : "px-4"} pt-6`}
            >
              {streamingState.showFirstCards && (
                <div className="w-full flex justify-center flex-col mb-6 gap-8">
                  <CardRound props={destinationData.slice(0, 2)} />
                </div>
              )}

              {/* 行程安排部分 */}
              <div className="mb-12">
                <div className="flex items-center mb-6">
                  <img src="/icon/list.png" alt="" className="w-6 h-5 mr-2" />
                  <h2 className="text-3xl font-extrabold">Itinerary</h2>
                </div>
                <div className="space-y-6">
                  {planData?.itinerary
                    ?.slice(0, streamingState.renderedItineraryDays)
                    .map(
                      (
                        day: {
                          day: string;
                          date: string;
                          schedule: Array<{ time: string; activity: string }>;
                        },
                        index: number
                      ) => {
                        const renderedScheduleCount =
                          streamingState.renderedItinerarySchedules[index] || 0;
                        return (
                          <div key={index} className="rounded-lg p-6">
                            <h3 className="text-xl font-bold mb-4">
                              {day.day} - {day.date}
                            </h3>
                            <div className="space-y-4 text-base">
                              {day.schedule
                                .slice(0, renderedScheduleCount)
                                .map((item, idx) => (
                                  <div
                                    key={idx}
                                    className="flex animate-fadeIn"
                                  >
                                    <span className="text-[#c9b077] font-semibold w-20">
                                      {item.time}
                                    </span>
                                    <span className="flex-1">
                                      {item.activity}
                                    </span>
                                  </div>
                                ))}
                            </div>
                          </div>
                        );
                      }
                    )}
                </div>
              </div>

              {streamingState.showSecondCards && (
                <div className="w-full flex justify-center flex-col mb-6 gap-8">
                  <CardRound props={destinationData.slice(2, 4)} />
                </div>
              )}

              {/* 景點推薦部分 */}
              {streamingState.showAttractionsTitle && (
                <div className="mb-12">
                  <div className="flex items-center mb-6 animate-fadeIn">
                    <img
                      src="/icon/label.png"
                      alt=""
                      className="w-5 h-5 mr-2"
                    />
                    <h2 className="text-3xl font-extrabold">Top Attractions</h2>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {planData?.topAttractions
                      ?.slice(0, streamingState.renderedAttractions)
                      .map(
                        (
                          attraction: {
                            name: string;
                            type: string;
                            description: string;
                            recommendedTime: string;
                          },
                          index: number
                        ) => (
                          <div
                            key={index}
                            className="rounded-lg p-6 animate-fadeIn"
                          >
                            <h3 className="text-lg font-bold mb-2">
                              {attraction.name}
                            </h3>
                            <div className="text-sm text-gray-600 mb-2">
                              {attraction.type}
                            </div>
                            <p className="text-gray-800 mb-4">
                              {attraction.description}
                            </p>
                            <div className="text-sm font-medium text-[#c9b077]">
                              Recommended time: {attraction.recommendedTime}
                            </div>
                          </div>
                        )
                      )}
                  </div>
                </div>
              )}

              {streamingState.showThirdCards && (
                <div className="w-full flex justify-center flex-col mb-6 gap-8">
                  <CardRound props={destinationData.slice(4, 6)} />
                </div>
              )}

              {/* 季節亮點部分 */}
              {streamingState.showSeasonalHighlightsTitle && (
                <div className="mb-12">
                  <div className="flex items-center mb-6 animate-fadeIn">
                    <img
                      src="/icon/highlight.png"
                      alt=""
                      className="w-5 h-5 mr-2"
                    />
                    <h2 className="text-3xl font-extrabold">
                      Seasonal Highlights
                    </h2>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
                    {planData?.seasonalHighlights?.length > 0 ? (
                      planData.seasonalHighlights
                        .slice(0, streamingState.renderedSeasonalHighlights)
                        .map(
                          (
                            highlight: {
                              name: string;
                              type: string;
                              description: string;
                              eventDate: string;
                            },
                            index: number
                          ) => (
                            <div
                              key={index}
                              className="rounded-lg p-6 animate-fadeIn"
                            >
                              <div className="flex items-center">
                                <h3 className="text-lg font-bold mb-2">
                                  {highlight.name}
                                </h3>
                                <span className="text-sm text-gray-600 mb-2 ml-3">
                                  ({highlight.type})
                                </span>
                              </div>

                              <p className="text-gray-800 mb-2">
                                {highlight.description}
                              </p>
                              <div className="text-sm font-semibold text-[#c9b077]">
                                When: {highlight.eventDate}
                              </div>
                            </div>
                          )
                        )
                    ) : streamingState.renderedSeasonalHighlights === 0 ? (
                      <div>....</div>
                    ) : null}
                  </div>
                </div>
              )}

              {streamingState.showFourthCards && (
                <div className="w-full flex justify-center flex-col mb-6 gap-8">
                  <CardRound props={destinationData.slice(6, 8)} />
                </div>
              )}

              {/* 當地活動部分 */}
              {streamingState.showLocalEventsTitle && (
                <div className="mb-12">
                  <div className="flex items-center mb-6 animate-fadeIn">
                    <img
                      src="/icon/event.png"
                      alt=""
                      className="w-5 h-5 mr-2"
                    />
                    <h2 className="text-3xl font-extrabold">Local Events</h2>
                  </div>
                  <div className="grid grid-cols-1 gap-6">
                    {planData?.localEvents?.length > 0 ? (
                      planData.localEvents
                        .slice(0, streamingState.renderedLocalEvents)
                        .map(
                          (
                            event: {
                              name: string;
                              type: string;
                              description: string;
                              eventDate: string;
                            },
                            index: number
                          ) => (
                            <div
                              key={index}
                              className="rounded-lg p-6 animate-fadeIn"
                            >
                              <div className="flex items-center">
                                <h3 className="text-lg font-bold mb-2">
                                  {event.name}
                                </h3>
                                <span className="text-sm text-gray-600 mb-2 ml-3">
                                  ({event.type})
                                </span>
                              </div>

                              <p className="text-gray-800 mb-2">
                                {event.description}
                              </p>
                              <div className="text-sm font-semibold text-[#c9b077]">
                                When: {event.eventDate}
                              </div>
                            </div>
                          )
                        )
                    ) : streamingState.renderedLocalEvents === 0 ? (
                      <div>....</div>
                    ) : null}
                  </div>
                </div>
              )}

              {streamingState.showFifthCards && (
                <div className="w-full flex justify-center flex-col mb-6 gap-8">
                  <CardRound props={destinationData.slice(8, 10)} />
                </div>
              )}

              {/* 旅行貼士部分 */}
              {streamingState.showTravelTipsTitle && (
                <div className="mb-12">
                  <div className="flex items-center mb-6 animate-fadeIn">
                    <img src="/icon/doc1.png" alt="" className="w-4 h-4 mr-2" />
                    <h2 className="text-3xl font-extrabold">Travel Tips</h2>
                  </div>
                  <div className="rounded-lg p-6">
                    <ul className="list-disc list-inside space-y-3">
                      {planData?.travelTips
                        ?.slice(0, streamingState.renderedTravelTips)
                        .map((tip: string, index: number) => (
                          <li
                            key={index}
                            className="text-gray-800 font-medium flex items-center animate-fadeIn"
                          >
                            <b className="mr-2 text-[8px]">●</b>
                            {tip}
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              )}

              {streamingState.showTravelBookingTitle && (
                <div className="mb-12">
                  <div className="flex items-center mb-6 animate-fadeIn">
                    <img
                      src="/icon/list2.png"
                      alt=""
                      className="w-5 h-6 mr-2"
                    />
                    <h2 className="text-3xl font-extrabold">Travel Booking</h2>
                  </div>
                  <div className="rounded-lg p-6">
                    <ul className="list-disc list-inside flex items-center gap-8">
                      {bookingLinks
                        .slice(0, streamingState.renderedTravelBooking)
                        .map((link, index) => (
                          <li
                            key={index}
                            className="w-20 rounded-lg flex items-center justify-center animate-fadeIn"
                          >
                            <Link
                              target="_blank"
                              rel="stylesheet"
                              to={link.href}
                              className="w-full h-full flex flex-col gap-2 items-center justify-center"
                            >
                              <div className="w-full h-[80px] rounded-lg bg-[#f6f6f6] p-2 flex items-center justify-center">
                                <img
                                  src={link.img}
                                  alt={link.label}
                                  className="w-full h-full object-contain"
                                />
                              </div>
                              <span className="text-sm text-center text-gray-800 font-medium">
                                {link.label}
                              </span>
                            </Link>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              )}

              {/* 返回按鈕 */}
              {streamingState.showBackButton && (
                <div className="flex justify-center pb-8 animate-fadeIn">
                  <button
                    type="button"
                    onClick={() => window.history.back()}
                    className="px-16 py-3 text-center text-white font-extrabold rounded-full bg-[#c9b077]/70 hover:bg-[#c9b077] disabled:bg-gray-400"
                  >
                    Back to AI Planner
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
